/**
 * Maps event category slugs to their universe type for cameleon theming on /devis
 */
const SLUG_TO_TYPE: Record<string, string> = {
  'wedding-design-scenographie': 'mariage',
  'wedding-planning-paris': 'mariage',
  'mariage-prestige': 'mariage',
  'anniversaire-signature': 'anniversaire',
  'demande-mariage-paris': 'demande',
  'soiree-entreprise-paris': 'professionnel',
  'conference-evenement-client': 'professionnel',
  'seminaire-team-building-prestige': 'professionnel',
  'evenement-createur-digital': 'professionnel',
};

export const getUniversTypeFromSlug = (slug?: string): string | null => {
  if (!slug) return null;
  return SLUG_TO_TYPE[slug] || null;
};
